import { RiWhatsappFill } from "react-icons/ri";

export const WhatsAppIcon = ({ customClasses = "w-6 h-6" }) => {
  return <RiWhatsappFill className={customClasses} />;
};
